//angular imports
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheDbService {

  // This mirrors private _knownKeys in C#
  private _knownKeys: Set<string> = new Set<string>();
  private _isInitialized: boolean = false;
  
  async initialize(): Promise<void> {

    if (this._isInitialized) {
      console.warn(`CacheDbService: Already initialized, skipping re-initialization`);
      return Promise.resolve();
    }

    console.debug(`CacheDbService: Initializing`);
    this._isInitialized = true;

    return new Promise((resolve, reject) => {      
      const openRequest = indexedDB.open("SpacebotCacheDB");

      openRequest.onupgradeneeded = (event: any) => {
        console.debug('CacheDbService: upgrade');

        var db = event.target.result;
        if (!db.objectStoreNames.contains("cache")) {
          db.createObjectStore("cache");
        }
      };

      openRequest.onsuccess = (event: any) => {
        const db: IDBDatabase = event.target.result;

        if (!db.objectStoreNames.contains('cache')) {
          db.close();
          
          resolve();
          return;
        }

        const transaction = db.transaction(['cache'], 'readonly');
        const store = transaction.objectStore('cache');
        const getKeysRequest = store.getAllKeys();

        getKeysRequest.onsuccess = () => {
          const keys = getKeysRequest.result as string[];
          // Populate the Set for O(1) lookups
          this._knownKeys = new Set(keys);
          db.close();
          resolve();
        };
      };

      openRequest.onerror = () => reject(openRequest.error);
    });
  }

  public Exists(key: string): boolean {
    // JavaScript is single-threaded, so we don't need a 'lock' 
    // keyword like C#, but the logic remains the same.
    return this._knownKeys.has(key);
  }

  // Helper to get the current count
  public get cacheCount(): number {
    return this._knownKeys.size;
  }
}